module.exports = __webpack_public_path__ + "media/images/lb/531-6ba84cf40f5e05a82adedb27796d5edd.svg";